import {ErrorHandler, isDevMode} from "@angular/core";

import {Subject} from "rxjs";

export class ErrorLoggerProxy implements ErrorHandler {

  static $onError = new Subject<any>();

  handleError(error: any) {
    console.error('ErrorLoggerProxy' + error);
    ErrorLoggerProxy.$onError.next(error);
  }
}
